import { Checkbox, Spin } from 'antd';
import { Link } from 'react-router-dom';

import { SubmitWrapper } from '@style/pages/form.style';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Input, InputPassword } from '@atom/form/input/input';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { TestIdsEnum } from '@enum/test-ids.enum';
import { Form } from '@form/common.style';
import { FormError } from '@form/form-error';
import { BaseFormInterface } from '@interface/form/base-form.interface';
import { getTestId } from '@util/data/get-test-id';

import { initialRegistrationForm } from './registration.form-initial';
import { registrationFormValidation } from './registration.form-validation';

export const RegistrationForm = ({ error, isLoading = false, form }: BaseFormInterface) => {
  const isAccepted = Form.useWatch('isAccepted', form);

  return (
    <Form form={form} initialValues={initialRegistrationForm} layout='vertical' name='registration'>
      <Form.Item
        label='First Name'
        name={['profile', 'name']}
        rules={[registrationFormValidation]}
        validateTrigger='onBlur'
      >
        <Input placeholder='Joe' {...getTestId(TestIdsEnum.SignUpFirstNameInput)} />
      </Form.Item>
      <Form.Item label='Last Name' name={['profile', 'lastname']} rules={[registrationFormValidation]}>
        <Input placeholder='Doe' {...getTestId(TestIdsEnum.SignUpLastNameInput)} />
      </Form.Item>
      <Form.Item label='Company website' name={['profile', 'company']} rules={[registrationFormValidation]}>
        <Input placeholder='Ex: http://website.com' {...getTestId(TestIdsEnum.SignUpCompanyInput)} />
      </Form.Item>
      <Form.Item label='Email' name='email' rules={[registrationFormValidation]}>
        <Input placeholder='my@mail.com' {...getTestId(TestIdsEnum.SignUpEmailInput)} />
      </Form.Item>
      <Form.Item label='Password' name='password' rules={[registrationFormValidation]}>
        <InputPassword placeholder='Password' {...getTestId(TestIdsEnum.SignUpPasswordInput)} />
      </Form.Item>
      <Form.Item name='isAccepted' valuePropName='checked'>
        <Checkbox {...getTestId(TestIdsEnum.SignUpCheckboxInput)}>
          <Text level='s'>
            I agree to the Subscriber Agreement and have read the{' '}
            <Link target='_blank' to='https://velory.com/legal/privacy-policy'>
              Privacy Policy
            </Link>
            .
          </Text>
        </Checkbox>
      </Form.Item>
      <SubmitWrapper>
        <Button
          disabled={!isAccepted}
          htmlType='submit'
          type={ButtonTypeEnum.Primary}
          block
          {...getTestId(TestIdsEnum.SignUpSubmitButton)}
        >
          {isLoading && <Spin />}
          {!isLoading && (
            <Text color={ColorEnum.White} letterSpacing={1.4}>
              SIGN UP
            </Text>
          )}
        </Button>
      </SubmitWrapper>
      <FormError error={error} errorField='email' />
    </Form>
  );
};
